<template>
  <div
    id="main"
    class="app"
  >
    <alert-panel/>
    <div
      v-if="isApplicationDone"
      class="app__content-wrapper"
    >
      <transition name="default-opacity-transition" mode="out-in">
        <router-view
          :class="subMenuClass"
          class="app__content"
        />
      </transition>
    </div>
    <s-loader
      v-else-if="isLoadingApplicationData"
      class="text-center pt-5"
      size="lg"
    />
    <message-modal/>
    <s-footer
      v-if="isFooterVisible"
      class="app__footer"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AlertPanel from '@/components/AlertPanel';
import MessageModal from '@/components/MessageModal';
import SFooter from '@/components/Footer';

export default {
  components: {
    SFooter,
    AlertPanel,
    MessageModal,
  },
  name: 'App',
  computed: {
    ...mapGetters({
      isAuthenticated: 'authenticated',
      subMenu: 'subMenu',
      isApplicationDone: 'appConfigurationLoaded',
      errorGettingApplicationData: 'errorGettingApplicationData',
      isPrinting: 'isPrinting',
      user: 'user',
      hotjarInjectionClass: 'hotjarInjectionClass',
    }),
    isFooterVisible() {
      return this.isAuthenticated && this.isApplicationDone;
    },
    subMenuClass() {
      return {
        'sub-menu--visible': this.subMenu.isVisible(),
        'sub-menu--collapsed': this.subMenu.collapsed,
        'is-printing': this.isPrinting,
      };
    },
    isFeedbackChecked() {
      return this.user?.feedbackButton && this.isApplicationDone ? 'block' : 'none';
    },
    isLoadingApplicationData() {
      return !this.isApplicationDone && !this.errorGettingApplicationData;
    },
  },
  methods: {
    changeHotjarVisibility() {
      const hotjarClassName = `.${this.hotjarInjectionClass}`;
      const selector = document.querySelector(hotjarClassName);

      if (!selector) {
        return;
      }

      selector.style.display = this.isFeedbackChecked;
    },
  },
  watch: {
    user() {
      this.changeHotjarVisibility();
    },
  },
};
</script>

<style src="normalize.css"></style>
<style src="./styles/global.sass" lang="sass"></style>
<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"
@import "src/styles/defaults/animation"

$side-menu-opened: calc(#{$desktop-menu-width} + #{$desktop-submenu-width})
$side-menu-closed: calc(#{$desktop-menu-width} + #{$desktop-menu-width})

.app
  @media not print
    flex: 1
    overflow: auto
    display: flex
    flex-direction: column

  &__content-wrapper
    width: 100%
    @media not print
      flex: 1
      overflow: auto
      &.force-overflow-y-scroll
        overflow-y: scroll
    @media print
      display: initial

  &__content:not(.login)
    min-height: 100%
    padding-left: $desktop-menu-width
    +media-max-sm()
      padding-left: 0
      padding-top: $mobile-menu-height
    @media print
      padding-left: 0
      padding-top: 0

    &.sub-menu--visible
      +media-min-md
        animation: none
        animation-iteration-count: unset

        @media screen
          @include padding-left-slide-animation($animation-name: 'open-side-menu',
          $start: $side-menu-closed,
          $end: $side-menu-opened,
          $time: $resize-duration)
      +media-max-sm()
        padding-left: 0
        padding-top: calc(#{$mobile-menu-height} + #{$mobile-submenu-height})
      @media print
        padding-left: 0
        padding-top: 0

    &.sub-menu--visible.sub-menu--collapsed
      +media-min-md
        animation: none
        animation-iteration-count: unset

        @media screen
          @include padding-left-slide-animation($animation-name: 'close-side-menu',
          $start: $side-menu-opened,
          $end: $side-menu-closed,
          $time: $resize-duration,
          $delay: $fade-out-duration)

      +media-max-sm()
        padding-left: 0
        padding-top: calc(#{$mobile-menu-height} + #{$mobile-submenu-height})
      @media print
        padding-left: 0
        padding-top: 0

  &__footer
    height: $footer-height
    +media-max-sm()
      height: 0

@media print
  .app__content
    &.sub-menu--visible
      padding-left: 0 !important

    &.sub-menu--visible.sub-menu--collapsed
      padding-left: 0 !important

</style>
